import type { Saga } from 'redux-saga';
import { call, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { track } from '@fff-web/fff-analytics';
import { selectTrackingData } from '../../selectors/trackingSelector';
import {
  PRODUCTS,
  receiveToggledFavorite,
  type RequestToggleFavoritesAction,
} from '../../services/actions/productsActions';
import { updateFavorite as _updateFavorite } from '../../services/api/products';
import { segmentEnum } from '../../utils/segment';

const { REQUEST_TOGGLE_FAVORITE } = PRODUCTS;

// WATCHER SAGAS
export function* watchUpdateFavorites(): Saga<void> {
  yield takeEvery(REQUEST_TOGGLE_FAVORITE, updateFavorite);
}

// WORKER SAGAS
function* updateFavorite(action: RequestToggleFavoritesAction): Saga<void> {
  const { productId, isLike } = action;
  const campaignId = yield select((state) => state.campaignState.campaignId);
  const toggledFavoriteResponse = yield call(_updateFavorite, campaignId, productId, isLike);

  yield put(receiveToggledFavorite(toggledFavoriteResponse));

  yield spawn(handleFavoriteTracking, action);
}

function* handleFavoriteTracking(action: RequestToggleFavoritesAction): Saga<void> {
  const { productId, variantId, buttonLocation, isLike, selectedCategoryId } = action;

  const trackingDataFromState = yield select((state) =>
    selectTrackingData(state, { productId, variantId, selectedCategoryId }),
  );

  const _trackingData = {
    ...trackingDataFromState,
    experience: buttonLocation,
  };

  const eventName = isLike ? segmentEnum.productFavorited : segmentEnum.productUnfavorited;

  track({ trackName: eventName });
}
